import { getCountry } from "../../../common/userfuctions";
import { post } from "../https";
const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;

const country = getCountry();

export const ShareJobOnLinkedIn = ({
  JobCode = "",
  NewsCode = "",
  AccessToken = "",
}) => {
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "ShareLinkedIn",
      JobCode: JobCode,
      NewsCode: NewsCode,
      AccessToken: AccessToken,
      IPCountry: country,
    }),
  };
  return post(SERVER_URL, null, params);
};
